import { CompanyType } from "@/api-schema-enums";
import { renderCompanyType } from "@/modules/masterdata/company/_helpers/type-renderer";
import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getCompanyTypeOptions(): { id: CompanyType; name: string }[] {
  return Object.values(CompanyType).map((type) => ({ id: type, name: renderCompanyType(type) }));
}

/**
 * Filter for company type
 * Uses the `type` field of the company search body schema
 */
export class CompanyTypeFilter extends Filter<{ type?: CompanyType[] }, Record<string, never>> {
  readonly id: string = "type";
  readonly labelSingular = "masterdata:CompanyType";
  readonly labelPlural = "masterdata:CompanyType";
  readonly placeholder = "masterdata:SelectCompanyType";
  readonly searchPlaceholder = "masterdata:SearchCompanyType";
  readonly emptyText = "masterdata:NoCompanyTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getCompanyTypeOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
